import {_modalControlReducer} from "./_modalControlReducer";
import {_warehouseCommonReducer} from "./_warehouseCommonReducer";

const initState = {}
export const warehouseComposeReducer = (state = initState, action) => ({
    ...state,
    ..._warehouseCommonReducer(state, action),
    modalControl: _modalControlReducer(state.modalControl, action),
})